<template>
    <form class="c-form c-form--stacked c-form--vertical">
        <div class="c-card c-card--small c-card--center u-animation--fade-in u-animation--fade-in-from-bottom">
            <div class="c-card__content">
                <h2>{{$t(i18n.text.title)}}</h2>

                <p>{{$t(i18n.text.disclaimer)}}</p>
                <p>{{$t(i18n.text.email)}} <br> {{form.email}}</p>
                <p>{{$t(i18n.text.role)}}<br> {{form.selectedRole.value}}</p>

                <div class="c-button-container">
                    <button @click.prevent="submit" class="o-button o-button--wide">{{$t(i18n.text.confirm)}}</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import {Utils} from "@bvm/core";

    const i18nBuilder = new Utils.I18n.I18nBuilder('employee_form_removal')
        .add('text', b => b
            .add('email')
            .add('role')
            .add('confirm')
            .add('disclaimer')
            .add('title')
        );
    export const messageKeys = i18nBuilder.getKeys();

    export default {
        name: "EmployeeRemovalConfirm",
        props: {
            form: {type: Object, required: true},
            employeeId: {type: Number, required: true}
        },
        data() {
            return {
                i18n: i18nBuilder.getData()
            }
        },
        methods: {
            submit() {
                this.$emit('confirm-removal');
            }
        }
    }
</script>
